const features = [
  {
    icon: 'ri-video-line',
    title: 'HD Video Lessons',
    description: 'Crystal-clear video lectures with closed captions, downloadable slides, and playback speed control.',
  },
  {
    icon: 'ri-code-box-line',
    title: 'Hands-On Projects',
    description: 'Every course includes real projects you can add to your portfolio and show to employers.',
  },
  {
    icon: 'ri-award-line',
    title: 'Certificates',
    description: 'Earn a shareable certificate of completion to showcase your new AI skills on LinkedIn.',
  },
  {
    icon: 'ri-infinity-line',
    title: 'Lifetime Access',
    description: 'Pay once, access forever — including all future updates and additions to the course.',
  },
  {
    icon: 'ri-message-3-line',
    title: 'Community & Q&A',
    description: 'Ask questions in our active learner community. Instructors respond within 24 hours.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Expert Instructors',
    description: 'Learn from AI researchers, engineers, and practitioners with real-world experience.',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-20 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-4 font-heading">
            Everything you need to succeed
          </h2>
          <p className="text-base sm:text-lg text-foreground-600 max-w-xl mx-auto">
            We've designed every aspect of our platform for maximum learning outcomes.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div key={feature.title} className="flex gap-4">
              <div className="shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-primary-600 text-lg w-5 h-5 flex items-center justify-center`} />
              </div>
              <div>
                <h3 className="font-semibold mb-1 text-foreground-950">{feature.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}